import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/trade/withdraw/$")({
  beforeLoad: () => {
    throw redirect({ to: "/trade/withdraw" });
  },
});
